import {div, button, p} from '@motorcycle/dom';

import isolate from '@cycle/isolate'

import most from 'most'


function intent(sources) {

  const decrement$ = sources.DOM
    .select('.decrement').events('click').map(i => ({type:'DEC'}));

  const increment$ = sources.DOM
    .select('.increment').events('click').map(i => ({type:'INC'}))

  return decrement$.merge(increment$);
}


function model(action$) {
  return action$.scan( (state,action) => {
    switch(action.type){
      case 'INC': return state + 1
      case 'DEC': return state - 1
      default: return state
    }
  }, 0)
}


function view(state$) {
  return state$.map(state =>
    div([
      button('.decrement', 'Decrement'),
      button('.increment', 'Increment'),
      p('Counter: ' + state)
    ])
  );
}


export default isolate( (sources)=> {

  const action$ = intent(sources)
  const state$ = model(action$)
  const vtree$ = view(state$)

  return {
    DOM: vtree$
  }
} )



/** WEBPACK FOOTER **
 ** ./components/incdec.js
 **/